import { INBOX_PERMISSIONS } from 'dashboard/constants/permissions.js';
import WhatsappCatalogsPage from './Index.vue';

// Catálogos seguem a mesma política dos WhatsApp Flows: administradores ou
// perfis com inbox_manage. O editor de modelos usa o nome `whatsapp_catalogs`.
export const routes = [
  {
    path: 'campanhas/whatsapp-catalogos',
    name: 'whatsapp_catalogs',
    meta: { permissions: ['administrator', INBOX_PERMISSIONS] },
    component: WhatsappCatalogsPage,
  },
];
